module.exports = __webpack_public_path__ + "img/B26F52_4B2E2B_79493A_663B32-256px.8854cf39.png";